import classnames from 'classnames/bind'

// Libs
import ImageComponent from '@/components/common/Image'
import { useTranslation } from 'next-i18next'

// Components
import Icon from '@/assets/icons'

// Constants
import { TUserProfile } from '@/types/user-profile'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

type TFollowInfoProps = {
  followers: TUserProfile[]
}

const DISPLAY_NAME_COUNT = 3

const HeadShot = ({ headshotUrl }: { headshotUrl: string }) => {
  if (!headshotUrl) return <Icon.DefaultHeadShot />
  return <ImageComponent src={headshotUrl} fill alt='avatar' style={{ objectFit: 'cover' }} />
}

const FollowersOverview = (props: TFollowInfoProps) => {
  const { followers } = props
  const { t } = useTranslation()
  const hasFollowers = followers.length > 0
  const followersCount = hasFollowers ? followers.length : 0
  const slicedFollowers = followers.slice(0, DISPLAY_NAME_COUNT)
  const moreCount = followersCount > DISPLAY_NAME_COUNT ? followersCount - DISPLAY_NAME_COUNT : 0
  const displayNames = slicedFollowers.map((follower) => follower.nickName).join(', ')

  return (
    <div className={cx('followers-overview')}>
      <div className={cx('followers-overview__avatars')}>
        {slicedFollowers.map((item) => (
          <span className={cx('followers-overview__avatars-item')} key={item.id}>
            <HeadShot headshotUrl={item.headshotUrl} />
          </span>
        ))}
      </div>
      <span className={cx('followers-overview-text')}>
        {t('Common_Followers_Overview_Description', {
          names: displayNames,
        })}{' '}
        {moreCount > 0 &&
          t('Common_Followers_More_Description', {
            names: displayNames,
            followersCount: moreCount,
          })}
      </span>
    </div>
  )
}
export default FollowersOverview
